<template>
  <div id="app">
    <header class="main-header" id="home">
		<div class="container-fluid">
				<!-- box header -->
				<div class="box-header">
						<div class="box-logo">
								<a style="color: #222434;" href="/">MK</a>
						</div>
						<!-- box-nav -->
						<a class="box-primary-nav-trigger" href="#0">
								<span class="box-menu-icon"></span>
						</a>
						<!-- box-primary-nav-trigger -->
				</div>
				<!-- end box header -->

				<!-- nav -->
				<nav>
						<ul class="box-primary-nav ">
								<li class="box-label">MALAIKA KUNLE</li>

								<li><a href="#home" class="home" >Home</a> <i class="lnr lnr-home"></i></li>
								<li><a href="#about" class="home" >About</a></li>
								<li><a href="#portfolio" class="home" >Portfolio</a></li>
								<li><a href="#contact" class="home" >Contact</a></li>

								<li class="box-label">SOCIAL</li>
								<li class="box-social"><a href="https://www.linkedin.com/in/malaika-kunle-3b7861b6/" target="_blank"><i class="fa fa-linkedin" aria-hidden="true"></i></a></li>
						</ul>
				</nav>
				<!-- end nav -->
				<section class="box-intro bg-film">
						<div class="table-cell">

								<h3 class="box-headline letters rotate-2">
										<span class="box-words-wrapper">
											  <b class="is-visible">SOFTWARE &nbsp; DEVELOPER.</b>
												<b>CLEAN &nbsp;&amp;&nbsp; CREATIVE.</b>
												<b>&nbsp;SIMPLE &nbsp;&amp;&nbsp; POWERFUL.</b>
										</span>
								</h3>
								<h1>MALAIKA KUNLE</h1>

						</div>

						<div class="mouse">
								<div class="scroll"></div>
						</div>
				</section>
		</div>
	</header>
  <About></About>
  <!-- <Services></Services> -->
  <Portfolio></Portfolio>
  <Contact></Contact>
    <router-view/>
  </div>
</template>

<script>
import About from "@/components/About.vue";
import Services from "@/components/Services.vue";
import Portfolio from "@/components/Portfolio.vue";
import Contact from "@/components/Contact.vue";
export default {
  name: "App",
  components: {
    About,
    Services,
    Portfolio,
    Contact
  }
};
</script>

<style>

.btn .btn__content .icon {
  color: black !important;
}
.jumbotron__image {
  position: absolute;
   width: 100%;
  top: 50%;
  width: 500px !important;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  min-width: 100%;
  will-change: transform;
  -webkit-transition: inherit;
  transition: inherit;
}

.carousel {
    box-shadow: none;
}
.box-logo {
    display: none;
}
.box-header.is-fixed a.box-primary-nav-trigger {
    margin-top: 20px;
}
.jumbotron {
    background: none;
}
.jumbotron__wrapper {
    overflow: visible;
}
</style>



// WEBPACK FOOTER //
// src/App.vue